import axios from 'axios';

export function getAxiosErrorMessage(error: unknown, fallbackMessage: string): string {
  if (axios.isAxiosError(error) && (error.response?.status === 400 || error.response?.status === 500)) {
    return error.response.data.message;
  } else {
    return fallbackMessage;
  }
}
